import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 其他-模块
 */
var other = {
  path: '/other',
  redirect: '/other/about',
  component: RootLayout,
  children: [{
    path: 'officialAccount',
    name: 'OfficialAccount',
    component: function component() {
      return import('views/other/OfficialAccount');
    },
    meta: {
      title: '关注公众号'
    }
  }, {
    path: 'joinCommunity',
    name: 'JoinCommunity',
    // 运营极其重要的路由，不能改！！！！
    component: function component() {
      return import('views/other/JoinCommunity');
    },
    meta: {
      title: '加入社区'
    }
  }, {
    path: 'sharePage',
    name: 'SharePage',
    component: function component() {
      return import('views/other/SharePage');
    }
  }, {
    path: 'downloadGuide',
    name: 'DownloadGuide',
    component: function component() {
      return import('views/other/DownloadGuide');
    },
    meta: {
      title: '应用下载'
    }
  },
  // {
  //   path: 'appDownload',
  //   name: 'AppDownload',
  //   component: () => import('views/other/AppDownload'),
  //   meta: {
  //     title: '应用下载'
  //   }
  // },
  {
    path: 'otherApp',
    name: 'OtherApp',
    component: function component() {
      return import('views/other/OtherApp');
    },
    meta: {
      title: '应用介绍'
    }
  }, {
    path: 'appTest',
    name: 'appTest',
    component: function component() {
      return import('views/testPage/Index');
    },
    meta: {
      title: 'AppTest'
    }
  }, {
    path: 'notice',
    name: 'Notice',
    component: function component() {
      return import('views/other/Notice');
    },
    meta: {
      title: '公告栏'
      // keepAlive: true
    }
  }, {
    path: 'noticeDetail/:id',
    name: 'NoticeDetail',
    component: function component() {
      return import('views/other/NoticeDetail');
    },
    meta: {
      title: '公告详情',
      normal: true // 普通页面，不需要登陆查询信息接口
    }
  }, {
    path: 'recruitmentOrder',
    name: 'RecruitmentOrder',
    component: function component() {
      return import('views/other/RecruitmentOrder');
    },
    meta: {
      title: '招募令'
    }
  },
  // {
  //   path: 'inviteFriend',
  //   name: 'InviteFriend',
  //   component: () => import('views/other/inviteFriend/index'),
  //   meta: {
  //     title: '邀请好友'
  //     // auth: true
  //   }
  // },
  // {
  //   path: 'poster',
  //   name: 'poster',
  //   component: () => import('views/other/inviteFriend/poster'),
  //   meta: {
  //     title: '邀请海报'
  //   }
  // },
  {
    path: 'talentList',
    name: 'talentList',
    component: function component() {
      return import('views/other/inviteFriend/talentList');
    },
    meta: {
      title: '邀请达人榜'
    }
  }, {
    path: 'invitedFriendBwl',
    name: 'invitedFriendBwl',
    component: function component() {
      return import('views/other/invitedFriendBwl/index');
    },
    meta: {
      title: '博物链邀请有礼'
    }
  }, {
    path: 'busynessPage',
    name: 'busynessPage',
    component: function component() {
      return import('views/other/busyness/BusynessPage');
    },
    meta: {
      title: '网络拥堵'
    }
  }, {
    path: 'exportPrivate',
    name: 'ExportPrivate',
    component: function component() {
      return import('views/other/exportPrivate/index.vue');
    },
    meta: {
      title: '导出私钥'
    }
  }, {
    path: 'customerService',
    name: 'CustomerService',
    component: function component() {
      return import('views/other/customerService/index.vue');
    },
    meta: {
      title: '在线客服'
    }
  }]
};
export default other;